const waga = { t: 'Waga', type: 'range', name: 'waga', unit: 'T' }
export default waga